import axios from "@/api/axiosInstance";

export const deleteSpecialty = async (uuid: string): Promise<void> => {
  await axios.delete(`/api/private/employee-directory/specialties/${uuid}`);
};
